/*
 *  Copyright
 *
 *  Tegona S.A.
 *
 *  Tegona JS © 2017, Tegona S.A.
 *
 *  ALL RIGHTS RESERVED. THIS PROGRAM CONTAINS MATERIAL PROTECTED
 *  UNDER INTERNATIONAL AND SWITZERLAND COPYRIGHT LAWS AND TREATIES.
 *  ANY UNAUTHORIZED USE OF THE PROGRAM, INCLUDING REPRODUCTION,
 *  MODIFICATION, TRANSFER, TRANSMITTAL OR REPUBLICATION OF THIS
 *  MATERIAL IN ANY FORM OR BY ANY MEANS IS PROHIBITED WITHOUT
 *  SPECIFIC WRITTEN PERMISSION OF THE COPYRIGHT HOLDER.
 *
 *  copyright@tegona.com
*/

import React from 'react'
import moment from 'moment'
import autoBind from 'react-autobind'
import R from 'ramda'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { injectIntl } from 'react-intl'
import { withRouter } from 'react-router-dom'

import { CircularProgress } from 'material-ui'
import AlertModal from 'generic/dialog/AlertModal'
import LoadingDialog from 'generic/dialog/LoadingDialog'
import { getDateTime } from 'utils/date'

import InterpreterSearch from './InterpreterSearch'
import PrestationCriterias from './PrestationCriterias'
import PrestationInformation from './PrestationInformation'
import PrestationValidation from './PrestationValidation'
import InterpreterList from './InterpreterList'
import ConsumerForm from 'components/common/consumer/Form'
import BeneficiaryForm from 'components/common/beneficiary/Form'

import * as constants from 'constants/Prestation'
import * as headerConstants from 'constants/Header'

import * as actions from 'actions/ApplicantPrestation'
import * as identityActions from 'actions/Identity'
import * as addressActions from 'actions/Address'
import * as beneficiaryActions from 'actions/Beneficiary'
import * as consumerActions from 'actions/Consumer'
import * as beneficiaryNumberActions from 'actions/BeneficiaryNumber'

import 'resources/styles/applicant/Creation.css'

class PrestationForm extends React.Component {

  constructor(props) {
    super(props)
    autoBind(this)

    this.state = {
      prestation: undefined,
      validatedPrestation: undefined,
      savePrestation: false,
      loading: false,
      showDetails: false,
      submitPrestation: false,
      origins: [],
      updateInterpreterSearch: false,
      showRecommendedDialog: false,
      interpreterListVisible: false,
      prestationInformationVisible: false,
      consumerFormVisible: false,
      beneficiaryFormVisible: false,
      errors: {}
    }
  }

  componentDidMount() {
    this.setState({
      loading: true,
    })

    let uid = this.props.match.params.uid
    if (this.props.history.location.params) {
      uid = this.props.history.location.params.uid
    }
    
    if (!uid && !this.props.user.newPrestationAccess) {
      this.props.history.push('/dashboard/')
    }

    this.props.actions.getPrestation(uid)
      .then((result) => {
        let prestation = {
            ...result,
            ordered_start_time: result.uid
              ? moment(result.ordered_start_time, 'HH:mm').format('HH:mm')
              : undefined,
            ordered_end_time: result.uid
              ? moment(result.ordered_end_time, 'HH:mm').format('HH:mm')
              : undefined,
            delivered_start_time: result.uid && result.delivered_start_time
              ? moment(result.delivered_start_time, 'HH:mm').format('HH:mm')
              : undefined,
            delivered_end_time: result.uid && result.delivered_end_time
              ? moment(result.delivered_end_time, 'HH:mm').format('HH:mm')
              : undefined
        }

        if (this.props.history.location.params &&
            this.props.history.location.params.prestation) {

            const chatbotData = this.props.history.location.params.prestation
            prestation = {
                ...chatbotData,
                invitations: [],
                interpreters: [],
            }

            this.setState({
                prestation: prestation,
                // loading: false,
                updateInterpreterSearch: true,
                interpreterListVisible: true,
                submitPrestation: true,
            })
        }

        // Merge with Chatbot
        // if (this.props.history.location.params &&
        //     this.props.history.location.params.prestation) {
        //   const chatbotData = this.props.history.location.params.prestation
        //   // Only merge fields that exist and are not undefined
        //   prestation = {
        //     ...chatbotData,
        //     }
        // //   this.state.updateInterpreterSearch = true
        // //   this.state.interpreterListVisible = true
        // }

        if (this.props.history.location.params &&
            this.props.history.location.params.duplicate) {
          let beneficiaryNumber
          let consumer

          if (prestation.beneficiary_numbers.length &&
              prestation.beneficiary_numbers[0].beneficiary &&
              prestation.beneficiary_numbers[0].beneficiary.identities.length) {
            const beneficiaryIdentity = {
              ...prestation.beneficiary_numbers[0].beneficiary.identities[0],
              uid: undefined
            }
            beneficiaryNumber = {
              ...prestation.beneficiary_numbers[0],
              uid: undefined,
              beneficiary: {
                ...prestation.beneficiary_numbers[0].beneficiary,
                identities: [beneficiaryIdentity],
                uid: undefined
              }
            }
          }
          
          if (prestation.consumers.length &&
              prestation.consumers[0].identities.length) {
            const consumerIdentity = {
              ...prestation.consumers[0].identities[0],
              uid: undefined
            }
            consumer = {
              ...prestation.consumers[0],
              identities: [consumerIdentity],
              uid: undefined
            }
          }
          prestation = {
            ...prestation,
            uid: undefined,
            id: undefined,
            choosenInterpreter: prestation.interpreter.uid ? prestation.interpreter.uid : undefined,
            ordered_date: moment(result.ordered_start_time) > moment()
              ? prestation.ordered_date
              : undefined,
            ordered_start_time: prestation.invoice_only_additional_services
              ? moment('23:55', 'HH:mm').format('HH:mm')
              : undefined,
            ordered_end_time: prestation.invoice_only_additional_services
              ? moment('23:59', 'HH:mm').format('HH:mm')
              : undefined,
            signature: undefined,
            preferred_sex: undefined,
            preferred_nationality_origin: undefined,
            preferred_qualifications: [],
            preferred_skills: [],            
            invitations: [],
            interpreters: [],
            beneficiary_numbers: beneficiaryNumber ? [beneficiaryNumber] : prestation.beneficiary_numbers,
            consumers: consumer ? [consumer] : prestation.consumers
          }
        }

        this.setState({
          prestation: prestation,
          loading: false
        })
      })
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.showDetails !== prevState.showDetails) {
      this.setState({
        prestationInformationVisible: this.state.showDetails
      })
    }

    if (this.state.consumerFormVisible !== prevState.consumerFormVisible) {
      this.setState({
        prestationInformationVisible: !this.state.consumerFormVisible,
        consumerFormVisible: this.state.consumerFormVisible
      })
    }

    if (this.state.beneficiaryFormVisible !== prevState.beneficiaryFormVisible) {
      this.setState({
        prestationInformationVisible: !this.state.beneficiaryFormVisible,
        beneficiaryFormVisible: this.state.beneficiaryFormVisible
      })
    }
  }

  handleStateChange(name, value) {
    this.setState({
      [name]: value
    })
  }

  handleChange(name, value) {
    this.setState({
      prestation: {
        ...this.state.prestation,
        [name]: value
      },
      errors: {
        ...this.state.errors,
        [name]: undefined
      }
    })
  }

  handleDateFormatChange(name, value) {
    this.setState({
      errors: {
        ...this.state.errors,
        [name]: undefined
      }
    })

    let date = value === '' ? undefined : value

    if (date && date.length === 10) {
      const formattedDate = moment(value, 'DD.MM.YYYY')
      if (moment(formattedDate, 'YYYY-MM-DD').isValid()) {
        date = moment(formattedDate).format('YYYY-MM-DD')
      } else {
        this.setState({
          errors: {
            ...this.state.errors,
            [name]: this.props.intl.formatMessage(constants.messages.DATE_INVALID)
          }
        })

        return
      }
    } else {
      this.setState({
        errors: {
          ...this.state.errors,
          [name]: this.props.intl.formatMessage(constants.messages.DATE_FORMAT)
        }
      })
    }

    this.handleChange(name, date)
  }

  handleDateChange(name, value) {
    const date = moment(value).format('YYYY-MM-DD')
    this.handleChange(name, date)
  }

  handleTwoDaysPrestation(name, value) {
    let startTime
    let endTime
    if (name === 'ordered_end_time') {
      startTime = this.state.prestation.ordered_start_time
      endTime = value
    } else if (name === 'ordered_start_time') {
      startTime = value
      endTime = this.state.prestation.ordered_end_time
    }

    if (!startTime ||
        !endTime ||
        !value ||
        (value && value.length === 1)) {
      return
    }

    let message
    if (moment(startTime, 'HH:mm').format('HH:mm') >= moment(endTime, 'HH:mm').format('HH:mm')) {
      message = this.props.intl.formatMessage(constants.messages.TWO_DAYS_PRESTATION, {
        value: this.state.prestation.ordered_date
          ? moment(this.state.prestation.ordered_date).add(1, 'days').format('DD.MM.YYYY')
          : ''
      })
    }

    this.setState({
      errors: {
        ...this.state.errors,
        ordered_end_time: message
      }
    })

  }

  handleTimeChange(name, value) {
    const time = moment(value).format('HH:mm')

    new Promise((resolve, reject) => {
      resolve(this.handleChange(name, time))
    }).then(() => {
      this.handleTwoDaysPrestation(name, time)
    })
  }

  handleTimeFormatChange(name, value) {
    this.setState({
      errors: {
        ...this.state.errors,
        [name]: undefined
      }
    })

    let time = value === '' ? undefined : value

    if (time && time.length === 5) {
      const formattedTime = moment(value, 'HH:mm')
      if (moment(formattedTime, 'HH:mm').isValid()) {
        time = moment(formattedTime)
        time = time.minute(Math.ceil(time.minute() / 5) * 5).format('HH:mm')
      } else {
        this.setState({
          errors: {
            ...this.state.errors,
            [name]: this.props.intl.formatMessage(constants.messages.TIME_INVALID)
          }
        })

        return
      }
    } else {
      this.setState({
        errors: {
          ...this.state.errors,
          [name]: this.props.intl.formatMessage(constants.messages.TIME_FORMAT)
        }
      })
    }

    new Promise((resolve, reject) => {
      resolve(this.handleChange(name, time))
    }).then(() => {
      this.handleTwoDaysPrestation(name, time)
    })
  }

  handleCheckConfirmation() {
    this.handleStateChange('submitPrestation', false)

    let prestation = this.state.prestation
    let showRecommendedDialog = false
    let errorObject = {}

    const selectedInterpreters = prestation.interpreters.filter(interpreter => interpreter.selected === true)
                                                        .map((interpreter) => {return {uid: interpreter.uid}})

    prestation = {
      ...prestation,
      ordered_start_time: prestation.ordered_start_time
        ? getDateTime(
            moment(prestation.ordered_date, 'YYYY-MM-DD'),
            moment(prestation.ordered_start_time, 'HH:mm')
          )
        : undefined,
      ordered_end_time: prestation.ordered_end_time
        ? getDateTime(
            moment(prestation.ordered_date, 'YYYY-MM-DD'),
            moment(prestation.ordered_end_time, 'HH:mm')
          )
        : undefined,
      delivered_start_time: prestation.delivered_date
        ? getDateTime(
            moment(prestation.delivered_date, 'YYYY-MM-DD'),
            moment(prestation.delivered_start_time, 'HH:mm')
          )
        : undefined,
      delivered_end_time: prestation.delivered_date
        ? getDateTime(
            moment(prestation.delivered_date, 'YYYY-MM-DD'),
            moment(prestation.delivered_end_time, 'HH:mm')
          )
        : undefined,
      paying_customer: prestation.paying_customer
        ? {'uid': prestation.paying_customer.uid}
        : undefined,
      interpreter: prestation.validation
        ? {uid: R.path(['interpreters', 0, 'uid'], prestation)}
        : prestation.interpreter,
      signature: prestation.validation
        ? constants.PRESTATION_NO_SIGNATURE
        : undefined,
      selected_interpreters: selectedInterpreters,
      preferred_sex: undefined,
      preferred_nationality_origin: undefined,
      preferred_qualifications: undefined,
      preferred_skills: undefined,
      additional_services: prestation.additional_services
        ? Math.ceil(prestation.additional_services / 5) * 5
        : undefined,
    }

    let addressPromise = prestation.address
    let beneficiaryIdentityPromise
    let consumerIdentityPromise

    const beneficiaryIdentity = R.path(['beneficiary_numbers', 0, 'beneficiary', 'identities', 0], prestation)
    if (beneficiaryIdentity) {
      beneficiaryIdentityPromise = identityActions.postIdentity(beneficiaryIdentity)
    }

    const consumerIdentity = R.path(['consumers', 0, 'identities', 0], prestation)
    if (consumerIdentity) {
      consumerIdentityPromise = identityActions.postIdentity(consumerIdentity)
    }
  

    if (!R.path(['address', 'uid'], prestation)) {
      if (prestation.invoice_only_additional_services &&
          !R.path(['address', 'address'], prestation)) {
        prestation = {
          ...prestation,
          address: {
            ...R.path(['applicant', 'entities', 0, 'address'], prestation),
            uid: undefined
          }
        }
      }

      addressPromise = addressActions.postAddress(prestation.address)
    }

    return Promise.all([
      addressPromise,
      beneficiaryIdentityPromise,
      consumerIdentityPromise
    ])
    .then((results) => {
      prestation = {
        ...prestation,
        address: results[0],
      }

      let beneficiaryPromise
      let consumerPromise

      if (results[1]) {
        prestation = {
          ...prestation,
          beneficiary_numbers: [{
            ...R.path(['beneficiary_numbers', 0], prestation),
            beneficiary: {
              ...R.path(['beneficiary_numbers', 0, 'beneficiary'], prestation),
              identities: [results[1]]
            }
          }],
        }
        beneficiaryPromise = beneficiaryActions.postBeneficiary(R.path(['beneficiary_numbers', 0, 'beneficiary'], prestation))
      }

      if (results[2]) {
        prestation = {
          ...prestation,
          consumers: [{
            ...R.path(['consumers', 0], prestation),
            identities: [results[2]]
          }],
        }

        consumerPromise = consumerActions.postConsumer(R.path(['consumers', 0], prestation))
      }

      return Promise.all([
        beneficiaryPromise,
        consumerPromise
      ])
    })
    .then((results) => {
      prestation = {
        ...prestation,
        beneficiary_numbers: [{
          ...R.path(['beneficiary_numbers', 0], prestation),
          beneficiary: results[0]
            ? {
                ...results[0],
                identities: undefined
              }
            : undefined
        }],
        consumers: results[1] ? [results[1]]: [],
      }

      return beneficiaryNumberActions.saveBeneficiaryNumber(R.path(['beneficiary_numbers', 0], prestation))
    })
    .then((result) => {
      prestation = {
        ...prestation,
        beneficiary_numbers: [result],
        documents: undefined,
      }

      return actions.postPrestationValidation(prestation)
    })
    .then(() => {
      showRecommendedDialog = constants.RECOMMANDED_FIELDS.some((key) =>  {
        let obj = prestation

        return key.split('.').some((i) => {
          obj = obj[i]

          return !obj || obj === '' || (Array.isArray(obj) && !obj.length)
        })
      })

      if (!showRecommendedDialog) {
        this.handleConfirm(prestation)
      }
    })
    .catch((errors) => {
      let message = ''

      if (R.path(['response', 'status'], errors)  === 400){
        R.map((errors) => (
          errorObject[errors.field_name] = errors.errors[0].user_message
        ), errors.response.data.field_errors)

        errors.response.data.field_errors.forEach(function (item, index) {
          if (message === '') {
            message = item.errors[0].user_message
          } else {
            message = message + '\n' + item.errors[0].user_message
          }
        })
      }

      this.props.actions.setNotification(message, headerConstants.NOTIF_ERROR)
    })
    .finally(() => {
      this.setState({
        submitPrestation: true,
        showRecommendedDialog: showRecommendedDialog,
        validatedPrestation: {
          ...prestation,
          preferred_sex: this.state.prestation.preferred_sex,
          preferred_nationality_origin: this.state.prestation.preferred_nationality_origin,
          preferred_qualifications: this.state.prestation.preferred_qualifications,
          preferred_skills: this.state.prestation.preferred_skills,          
        },
        prestation: {
          ...this.state.prestation,
          beneficiary_numbers: prestation.beneficiary_numbers,
          consumers: prestation.consumers,
          address: prestation.address,
          errors: errorObject
        },
        errors: errorObject,
      })
    })
  }

  handleConfirm(prestation) {
    this.setState({
      savePrestation: true,
      showRecommendedDialog: false
    })

    const { invitations: _, ...obj} = prestation || this.state.validatedPrestation

    actions.postPrestation(obj)
      .then((result) => {
        const i18nText = obj.uid
          ? headerConstants.messages.UPDATE_SUCCESS
          : headerConstants.messages.CLAIM_SUCCESS

        this.props.actions.setNotification(
          this.props.intl.formatMessage(i18nText, {id:result.data.object.id}),
          headerConstants.NOTIF_SUCCESS
        )

        this.props.history.push('/dashboard/')
      })
      .finally(() => {
        this.setState({
          savePrestation: false
        })
      })
  }

  handleShowValidationInformation() {
    if (!this.state.prestation.uid) {
      return false
    }

    const prestationStep = this.state.prestation.workflow_objects[0].step_name

    if (this.props.user.updatePaidPrestation) {
      return prestationStep === constants.VALIDATED_PRESTATION_STATUS ||
             prestationStep === constants.CANCELLED_PRESTATION_STATUS ||
             prestationStep === constants.PAID_PRESTATION_STATUS ||
             prestationStep === constants.INVOICED_PRESTATION_STATUS ||
             prestationStep === constants.TO_VERIFY_PRESTATION_STATUS ||
             prestationStep === constants.CLOSED_PRESTATION_STATUS
    } else if (this.props.user.is_staff) {
      return prestationStep === constants.VALIDATED_PRESTATION_STATUS ||
             prestationStep === constants.CANCELLED_PRESTATION_STATUS ||
             prestationStep === constants.PAID_PRESTATION_STATUS
    }

    return false
  }

  render () {
    return (
      <div
        style={styles.container}
        className='row'
      >
        {
          !this.state.prestation ||
          this.state.loading
            ? <CircularProgress
              size={200}
              style={{
                width: '100%',
                height: 300,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            />
            : <React.Fragment>
              {
                this.state.savePrestation
                  ? <LoadingDialog
                    message={
                      <React.Fragment>
                        <div style={{color: 'white',fontSize: '3vw'}}>
                          {this.props.intl.formatMessage(constants.messages.LOADING_PLEASE_WAIT_MESSAGE1)}
                        </div>
                        <div style={{color: 'white',fontSize: '3vw'}}>
                          {this.props.intl.formatMessage(constants.messages.LOADING_PLEASE_WAIT_MESSAGE2)}
                        </div>
                      </React.Fragment>
                    }
                  />
                  : undefined
              }

              {
                this.state.showDetails &&
                !this.handleShowValidationInformation()
                  ?  <div
                      id='prestationCriterias'
                      className='col-md-3 col-xs-12 first-md last-xs'
                      style={styles.cardStyle}
                    >
                     <PrestationCriterias
                      prestation={this.state.prestation}
                      handlePrestationChange={this.handleChange}
                      handleFormChange={this.handleStateChange}
                      origins={this.state.origins}
                    />
                    </div>
                  : undefined
              }

              {
                this.state.showDetails &&
                this.handleShowValidationInformation()
                  ?  <div
                      id='prestationCriterias'
                      className='col-md-3 col-xs-12 first-md last-xs'
                      style={styles.cardStyle}
                    >
                      <PrestationValidation
                        prestation={this.state.prestation}
                        handlePrestationChange={this.handleChange}
                        handleFormChange={this.handleStateChange}
                        handleDateFormatChange={this.handleDateFormatChange}
                        handleTimeFormatChange={this.handleTimeFormatChange}
                        handleDateChange={this.handleDateChange}
                        handleTimeChange={this.handleTimeChange}
                        errors={this.state.errors}
                      />
                    </div>
                  : undefined
              }

              <div
                id='interpreterSearch'
                className={
                  !this.state.showDetails
                    ? 'col-md-offset-3 col-md-6 col-xs-12 first-xs'
                    : 'col-md-5 col-xs-12 last-md'
                }
                style={{
                  ...styles.cardStyle,
                  position: 'relative'
                }}
              >
                <InterpreterSearch
                  prestation={this.state.prestation}
                  handlePrestationChange={this.handleChange}
                  isStaff={this.props.user.is_staff}
                  handleFormChange={this.handleStateChange}
                  updateInterpreterSearch={this.state.updateInterpreterSearch}
                  handleDateFormatChange={this.handleDateFormatChange}
                  handleTimeFormatChange={this.handleTimeFormatChange}
                  handleDateChange={this.handleDateChange}
                  handleTimeChange={this.handleTimeChange}
                  errors={this.state.errors}
                />

                <InterpreterList
                  isVisible={this.state.interpreterListVisible}
                  prestation={this.state.prestation}
                  handlePrestationChange={this.handleChange}
                  handleFormChange={this.handleStateChange}
                  updateInterpreterSearch={this.state.updateInterpreterSearch}
                  formVisible={this.state.consumerFormVisible || this.state.beneficiaryFormVisible}
                />
              </div>

              {
                this.state.prestationInformationVisible
                  ? <div
                    id='prestationInformation'
                    className={
                      this.state.showDetails ||
                      this.handleShowValidationInformation()
                        ? 'col-md-4 col-xs-12 last-md'
                        : 'col-md-6 col-xs-12 last-md'
                    }
                    style={styles.cardStyle}
                  >
                    <PrestationInformation
                      prestation={this.state.prestation}
                      handlePrestationChange={this.handleChange}
                      isStaff={this.props.user.is_staff}
                      handleFormChange={this.handleStateChange}
                      handleCheckConfirmation={this.handleCheckConfirmation}
                      submitPrestation={this.state.submitPrestation}
                    />
                  </div>
                  : undefined
              }

              {
                this.state.consumerFormVisible
                  ? <div
                    id='consumerForm'
                    className={
                      this.state.showDetails ||
                      this.handleShowValidationInformation()
                        ? 'col-md-4 col-xs-12 last-md'
                        : 'col-md-6 col-xs-12 last-md'

                    }
                    style={styles.cardStyle}
                  >
                    <ConsumerForm
                      prestation={this.state.prestation}
                      handlePrestationChange={this.handleChange}
                      handleFormChange={this.handleStateChange}
                    />
                  </div>
                  : undefined
              }

              {
                this.state.beneficiaryFormVisible
                  ? <div
                    id='beneficiaryForm'
                    className={
                      this.state.showDetails ||
                      this.handleShowValidationInformation()
                        ? 'col-md-4 col-xs-12 last-md'
                        : 'col-md-6 col-xs-12 last-md'

                    }
                    style={styles.cardStyle}
                  >
                    <BeneficiaryForm
                      prestation={this.state.prestation}
                      handlePrestationChange={this.handleChange}
                      handleFormChange={this.handleStateChange}
                    />
                  </div>
                  : undefined
              }

              <AlertModal
                open={this.state.showRecommendedDialog}
                title={this.props.intl.formatMessage(constants.messages.RECOMMANDED_FIELD_TITLE)}
                type={AlertModal.CONFIRM}
                handleCancel={() => this.handleStateChange('showRecommendedDialog', false)}
                handleConfirm={() => this.handleConfirm()}
                cancellationLabel={this.props.intl.formatMessage(constants.messages.NO_RECOMMANDED_FIELD_ACTION)}
                confirmationLabel={this.props.intl.formatMessage(constants.messages.YES_RECOMMANDED_FIELD_ACTION)}
              >
                <div>
                  <p>{this.props.intl.formatMessage(constants.messages.RECOMMANDED_FIELD_MESSAGE1)}</p>
                  <ul>
                    {
                      this.state.prestation &&
                      !R.path(['prestation', 'beneficiary_numbers', 0, 'beneficiary'], this.state)
                      ? <li>{this.props.intl.formatMessage(constants.messages.STEP_THREE_BENEFICIARY)}</li>
                      : undefined
                    }

                    {
                      this.state.prestation &&
                      !this.state.prestation.consumers.length
                      ? <li>{this.props.intl.formatMessage(constants.messages.STEP_THREE_CONSUMER)}</li>
                      : undefined
                    }

                    {
                      this.state.prestation &&
                      !this.state.prestation.reason
                      ? <li>{this.props.intl.formatMessage(constants.messages.STEP_THREE_REASONS)}</li>
                      : undefined
                    }
                  </ul>
                  <p>{this.props.intl.formatMessage(constants.messages.RECOMMANDED_FIELD_MESSAGE2)}</p>
                </div>
              </AlertModal>
            </React.Fragment>
        }
			</div>
    )
  }
}

const styles = {
  container: {
    marginLeft: 5,
    marginRight: 5,
  },
  cardStyle: {
    marginTop: 5,
    marginBottom: 5,
    width: '100%',
  }
}

const mapStateToProps = (state) => ({
  user: state.User.user,
})

const mapActionsToProps = (dispatch) => ({
  actions: bindActionCreators(actions, dispatch),
})

export default withRouter(
  connect(mapStateToProps, mapActionsToProps)
  (injectIntl(PrestationForm))
)



// WEBPACK FOOTER //
// ./src/components/applicant/prestation/creation/PrestationForm.js